import { Box, Grid, Paper, Skeleton, Stack } from '@mui/material';

/**
 * Skeleton placeholders shown while Apply-driven data loads, so KPI cards and
 * tables reserve their space instead of flashing a spinner / collapsing.
 */

/**
 * A grid of KPI-card skeletons.
 * @param {{ count?: number, md?: number }} props
 */
export function KpiCardsSkeleton({ count = 4, md = 3 }) {
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {Array.from({ length: count }).map((_, i) => (
        <Grid key={i} size={{ xs: 12, sm: 6, md }}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Skeleton variant="text" width="60%" height={20} />
            <Skeleton variant="text" width="40%" height={36} />
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}

/**
 * A table skeleton: a header bar plus `rows` shimmer lines.
 * @param {{ rows?: number }} props
 */
export function TableSkeleton({ rows = 6 }) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Skeleton variant="rectangular" height={32} sx={{ mb: 1, borderRadius: 1 }} />
      <Stack spacing={1}>
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={28} sx={{ borderRadius: 0.5 }} />
        ))}
      </Stack>
    </Paper>
  );
}

/** A single chart-area skeleton block. */
export function ChartSkeleton({ height = 300 }) {
  return (
    <Box sx={{ width: '100%' }}>
      <Skeleton variant="rectangular" height={height} sx={{ borderRadius: 1 }} />
    </Box>
  );
}
